export default __webpack_public_path__ + "static/media/TrashIcon.9a42181e.svg";